// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoicePreviewResponseSchema } from './v1/invoicePreviewResponseSchema';
import { v1InvoicesCreateSchema } from './v1/invoices/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const previewInvoicePathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const previewInvoiceHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoice preview
 */
export const previewInvoice200Schema = z.lazy(() => v1InvoicePreviewResponseSchema);

/**
 * @description Unauthorized
 */
export const previewInvoice401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const previewInvoiceMutationRequestSchema = z.lazy(() => v1InvoicesCreateSchema);

export const previewInvoiceMutationResponseSchema = z.lazy(() => previewInvoice200Schema);
